document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");

  if (tabButtons && tabButtons.length) {
    tabButtons.forEach(function (tabButton) {
      tabButton.addEventListener("click", function (event) {
        const target = tabButton.dataset.target;

        const activeTabButton = document.querySelector(".tab-button.active");
        if (activeTabButton) {
          activeTabButton.classList.remove("active");
        }
        tabButton.classList.add("active");

        const activeTabs = document.querySelectorAll(".tab-content.active");
        if (activeTabs && activeTabs.length) {
          activeTabs.forEach(function (activeTab) {
            activeTab.classList.remove("active");
          });
        }

        const targetTab = document.querySelector(`.tab-content#${target}`);
        if (targetTab) {
          targetTab.classList.add("active");
        }
      });
    });
  }
});
